import { Box, Image, Text } from '@betty/moonlight';

function PlayWithCoinsBanner() {
  return (
    <Box
      display="flex"
      flexDirection="row"
      variant="gradient"
      marginRight="-space-600"
      marginLeft="-space-600"
      marginBottom="space-400"
      gradient="accentBackgroundHover"
      overflow="hidden"
      position="relative"
      maxHeight={100}
    >
      <Box padding="space-600">
        <Text variant="body-m" locNS="games" locKey="playWithYour" />
        <Text variant="h5" locNS="games" locKey="bettyCoinsBalance" />
      </Box>
      <Box position="relative" flex={1} alignItems="flex-end">
        <Image
          name="common.FallingCoins"
          width="100%"
          height="100%"
          position="absolute"
          contentFit="cover"
          maxWidth={670}
          // transform={`translate(0px,-165px)`}
        />
      </Box>
    </Box>
  );
}

export default PlayWithCoinsBanner;
